/* lib/academy/resume.js — «продолжить с того места, где остановился» (ST-10).
 *
 * До этого resume-полоса вела на `/learning/c/<id>` без урока, и ученик попадал
 * на экран «Выберите урок» — то есть кнопка «Продолжить» ничего не продолжала.
 * Урок для возобновления считает бэк (`next_lesson_id` в записи), но полагаться
 * ТОЛЬКО на него нельзя: карточка «Моих курсов» и дерево курса — разные ответы,
 * и в дереве урок мог за это время закрыться (методист переставил порядок,
 * сменился тариф). Поэтому в плеере значение бэка перепроверяется по дереву, а
 * при расхождении считается по тем же правилам локально. */

/** Плоский список уроков дерева курса в порядке рельса. */
function flatLessons(tree) {
  const modules = (tree && tree.modules) || [];
  return modules.flatMap((m) => (m && m.lessons) || []);
}

/** Урок, с которого ученику продолжать в ЭТОМ дереве, или null (открытых нет).
 *  Правило зеркалит `services.pick_next_lesson_id`: последний открытый урок в
 *  работе (на нём и остановились) → первый открытый незавершённый → первый
 *  открытый (курс пройден целиком, возвращаемся к началу). */
export function nextLessonIdFromTree(tree) {
  const open = flatLessons(tree).filter((l) => l && !l.lock);
  if (!open.length) return null;
  const hinted = tree && tree.enrollment && tree.enrollment.next_lesson_id;
  if (hinted && open.some((l) => l.id === hinted)) return hinted;
  const started = open.filter((l) => l.progress === 'in_progress');
  if (started.length) return started[started.length - 1].id;
  const unfinished = open.find((l) => l.progress !== 'completed');
  return (unfinished || open[0]).id;
}

/** Адрес плеера для карточки/полосы «Мои курсы».
 *  `next_lesson_id` есть — ведём сразу в урок; нет — просто в плеер, он выберет
 *  урок сам (см. `nextLessonIdFromTree`), но уже без промежуточного экрана. */
export function playerPath(course) {
  if (!course) return '/learning';
  const id = course.course_id || course.id;
  const lesson = course.next_lesson_id;
  return `/learning/c/${id}` + (lesson ? `?lesson=${lesson}` : '');
}

/** Ученик уже начинал курс? От этого зависит только подпись полосы: «Продолжить»
 *  или «Начать» — саму полосу при 0 % тоже показываем (раньше её не было вовсе,
 *  и записанный, но не начавший ученик не видел точки входа). */
export function isStarted(course) {
  return !!course && Number(course.progress_pct || 0) > 0;
}
